import React from 'react';
import { TIMEZONE_OPTIONS, getTimezoneDisplayName, formatDateTime } from '../../utils/timezone';

interface TimezoneSelectorProps {
  value: string;
  onChange: (timezone: string) => void;
  disabled?: boolean;
  showPreview?: boolean;
  className?: string;
}

const TimezoneSelector: React.FC<TimezoneSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  showPreview = true,
  className = ''
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="block w-full rounded-md theme-border-primary theme-shadow-sm theme-border-focus theme-input sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed theme-transition"
      >
        {TIMEZONE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      
      {showPreview && (
        <div className="text-xs theme-text-tertiary space-y-1">
          <div>
            当前时区: {getTimezoneDisplayName(value)}
          </div>
          <div>
            当前时间: {formatDateTime(new Date(), { 
              showTimezone: true, 
              timezone: value 
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default TimezoneSelector; 